const r = (s) => (t) => typeof t == "string" && t.startsWith(s), a = /* @__PURE__ */ r("--"), e = /* @__PURE__ */ r("var(--"), n = (s) => e(s) ? i.test(s.split("/*")[0].trim()) : !1, i = /var\(--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)$/iu;
export {
  a as isCSSVariableName,
  n as isCSSVariableToken
};
